import * as React from "react"
import {
    Create,
    usePermissions,
} from "react-admin"
import { NewActionsTabs } from "components/ui/layouts"
import Form from "./form"


function UserCreate(props: React.PropsWithChildren): JSX.Element  {
    const { permissions } = usePermissions()

    return (
        <Create redirect="show" actions={<NewActionsTabs />}>
            <Form newRecord />
        </Create>
    )
}

export default UserCreate
